import { useAuth } from '@/app/providers/AuthProvider';
import { Button } from '@/ui';
import styles from './SessionBanner.module.css';

/**
 * Warns before the session dies.
 *
 * The token lasts 60 minutes and there is no refresh endpoint, so the only remedy is
 * to sign in again — which is far better offered here, in advance, than discovered
 * when a save fails. The legacy app gave no warning and wiped the page on the
 * resulting 401.
 */
export function SessionBanner() {
  const { expiresInMs, signOut } = useAuth();

  if (expiresInMs === null) return null;

  const minutes = Math.max(1, Math.ceil(expiresInMs / 60_000));

  return (
    <div className={styles.banner} role="status">
      <p className={styles.message}>
        Your session ends in {minutes} minute{minutes === 1 ? '' : 's'}. Save any work in
        progress — you will need to sign in again.
      </p>
      <Button size="sm" variant="secondary" onClick={() => signOut()}>
        Sign in again
      </Button>
    </div>
  );
}
